const LANGUAGE_NAMES = { 'en-GB': 'English (United Kingdom)', 'en-US': 'English (United States)', 'en-AU': 'English (Australia)', 'en-IE': 'English (Ireland)' };

export function voiceLabel(voice) {
  const conciseName = (voice?.name || 'System voice').replace(/ Online \(Natural\).*$/i, '').replace(/ - [^-]+$/, '').trim();
  const language = LANGUAGE_NAMES[voice?.lang] || voice?.lang;
  return language ? `${conciseName}, ${language}` : conciseName;
}
